import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import GifLoder from "./GifLoder";

const PublicOnlyRoute = ({ element: Component }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <GifLoder />;
  }

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return <Component />;
};

export default PublicOnlyRoute;
